// extracted by mini-css-extract-plugin
export default {"error-boundary":"uZXcFT","errorBoundary":"uZXcFT","antena":"cpPcYC","content":"nl2rsa","mobile-heading":"SFdJmU","mobileHeading":"SFdJmU"};